import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { PageHero } from "../components/PageHero";
import { CtaBand } from "../components/CtaBand";
import { SERVICES } from "../data/services";
import { IMAGES } from "../data/site";

export default function ServicesIndex() {
    return (
        <div data-testid="services-index-page">
            <Seo
                title="Security Services Scotland | 17 SIA Licensed Services | Xtreme Protection"
                description="Explore all 17 specialist security services across Scotland: manned guarding, door supervision, CCTV monitoring, mobile patrols, event security, K9 units and more."
            />
            <PageHero
                image={IMAGES.cctv}
                imageAlt="CCTV control room monitoring Scottish security sites"
                kicker="Scotland Security Operations // The Arsenal"
                title="17 Specialist Security"
                titleAccent="Services in Scotland"
                sub="Every service delivered by SIA-licensed, BS 7858 vetted officers with verified digital reporting — layered into packages built from a fresh risk assessment, not a sales template."
                testidPrefix="services-index"
            />
            <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
                    {SERVICES.map((s, i) => (
                        <Reveal key={s.slug} delay={(i % 3) * 0.06}>
                            <Link
                                to={`/services/${s.slug}`}
                                data-testid={`services-index-card-${s.slug}`}
                                className="group block bg-[#0F1117] hover:bg-[#161922] transition-colors duration-300 p-7 h-full"
                            >
                                <div className="flex items-start justify-between">
                                    <span className="font-mono-xp text-[11px] text-[#E53E3E] tracking-widest">{String(i + 1).padStart(2, "0")}</span>
                                    <ArrowRight size={16} className="text-gray-600 group-hover:text-[#E53E3E] group-hover:translate-x-1 transition-all duration-300" />
                                </div>
                                <h2 className="font-display uppercase font-bold text-2xl tracking-wide text-white mt-4 group-hover:text-[#E53E3E] transition-colors duration-300">
                                    {s.name}
                                </h2>
                                <p className="text-gray-500 text-sm leading-relaxed mt-2.5">{s.short}</p>
                            </Link>
                        </Reveal>
                    ))}
                </div>
            </section>
            <CtaBand />
        </div>
    );
}
